export const TaxYearTableConfig = [
    {
        columnId: 'tax_year',
        labelKey: 'Dox.DocumentExplorer.TaxYear',
        isDefaultSort: true,
        width: 12,
        isSortable: true
    }
]

export const FileExplorerFileTableConfig = [
    {
        columnId: 'count',
        labelKey: 'Dox.DocumentExplorer.Count',
        isDefaultSort: false,
        width: 1,
        isSortable: false,
        justifyContent: 'flex-start'
    },
    {
        columnId: 'name',
        labelKey: 'Dox.DocumentExplorer.Name',
        isDefaultSort: false,
        width: 3,
        isSortable: true,
        justifyContent: 'flex-start'
    },
    {
        columnId: 'size',
        labelKey: 'Dox.DocumentExplorer.Size',
        isDefaultSort: false,
        width: 2,
        isSortable: true,
        justifyContent: 'flex-end'
    },
    {
        columnId: 'modified',
        labelKey: 'Dox.DocumentExplorer.Modified',
        isDefaultSort: true,
        width: 3,
        isSortable: true,
        justifyContent: 'flex-start'
    },
    {
        columnId: 'uploader',
        labelKey: 'Dox.DocumentExplorer.Uploader',
        isDefaultSort: false,
        width: 2,
        isSortable: true,
        justifyContent: 'flex-start'
    },
    {
        columnId: 'manage',
        labelKey: 'Dox.DocumentExplorer.Manage',
        isDefaultSort: false,
        width: 1,
        isSortable: false,
        justifyContent: 'flex-end'
    }
]




